import React from "react";

const RPO = () => {
  return (
    <section className="min-h-screen flex items-center justify-center p-6 pt-16 bg-gray-100">
      <article className="bg-transparent shadow-lg rounded-2xl p-8 w-full max-w-3xl">
        <header className="text-center mb-6">
          <h2 className="text-3xl font-bold text-blue-600">
            Recruitment Process Outsource (RPO)
          </h2>
        </header>

        <section className="mb-6">
          <p className="text-gray-700">
            <b>Recruitment Process Outsourcing (RPO)</b> by <b>Talennect</b>{" "}
            offers businesses a seamless, scalable, and cost-effective hiring
            solution. Our team of recruitment specialists manages your entire
            hiring process—from talent sourcing and screening to
            onboarding—allowing you to focus on business growth while we find
            the right talent for you.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Why Choose RPO?
          </h3>
          <p className="text-gray-700">
            Hiring the right talent can be time-consuming and
            resource-intensive. With <b>Talennect’s RPO solutions</b>, you gain
            access to a vast talent network, AI-driven hiring strategies, and
            industry expertise. Our data-driven approach ensures faster, more
            efficient recruitment while reducing costs and improving hiring
            quality.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Our RPO Process
          </h3>
          <p className="text-gray-700">
            Our end-to-end RPO services cover every stage of the recruitment
            process, including{" "}
            <b>
              job profiling, candidate sourcing, screening, interviewing,
              assessments, background checks, and onboarding
            </b>
            . We work closely with your HR team to align hiring strategies with
            your business objectives, ensuring a seamless and efficient
            recruitment experience.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Industries We Serve
          </h3>
          <p className="text-gray-700">
            <b>Talennect’s RPO services</b> support businesses across industries
            such as{" "}
            <b>IT, healthcare, finance, engineering, manufacturing, and more</b>
            . Whether you're scaling rapidly or require specialized hiring
            expertise, our RPO solutions are tailored to meet your unique
            workforce needs.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-blue-600">
            Partner with Talennect for Smarter Hiring
          </h3>
          <p className="text-gray-700">
            Elevate your recruitment strategy with{" "}
            <b>Talennect’s RPO services</b>. Let our experts handle your hiring
            needs while you focus on driving business success. Contact us today
            to learn how our <b>outsourced recruitment solutions</b> can enhance
            your talent acquisition efforts.
          </p>
        </section>
      </article>
    </section>
  );
};

export default RPO;
